import React, { useEffect, useState } from "react";
import { Table, Typography, Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import colors from "../assets/styles/colour";
import CustomTable from "../components/TableComponent/CustomTable";

function AssemblyElectionDetailsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [columns, setColumns] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const electionDetails = location.state?.electionDetails || [];

  useEffect(() => {
    if (electionDetails.length > 0) {
      // Dynamically create columns from keys of the first object
      const dynamicColumns = Object.keys(electionDetails[0]).map((key) => ({
        title: key,
        dataIndex: key,
        key,
      }));
      setColumns(dynamicColumns);
      setDataSource(electionDetails);
    }
  }, [electionDetails]);

  return (
    <div style={{ padding: "20px" }}>
      {/* Go Back Button */}
      <Button
        type="primary"
        icon={<LeftOutlined />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: "20px", background: colors.primary }}
      >
        Go Back
      </Button>

      <Typography.Title level={3}>Election Details</Typography.Title>
      <CustomTable
        columns={columns}
        dataSource={electionDetails}
        rowKey={(record) => record.key}
        pagination={{ pageSize: 10 }}
        style={{
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          backgroundColor: "#fff",
          width: "100%",
          overflowX: "auto",
        }}
        scroll={{ x: 800 }}
      />
    </div>
  );
}

export default AssemblyElectionDetailsPage;
